module.exports = __webpack_public_path__ + "src-notif-travelocity.png?e3d342e4311ef32a2fc65aeae05a4ddd";